import { NgIf, NgForOf, AsyncPipe, NgStyle, NgClass, NgSwitchCase, NgSwitch, DecimalPipe, JsonPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Output,
  QueryList,
  ViewChildren,
  inject,
} from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { FormlyNgZorroAntdModule } from '@ngx-formly/ng-zorro-antd';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTableModule } from 'ng-zorro-antd/table';
import { Subject, Observable, debounceTime, distinctUntilChanged, lastValueFrom, switchMap, take } from 'rxjs';
import { PaginationService } from './service/pagination.service';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NzModalService } from 'ng-zorro-antd/modal';
import { TableInputComponent } from './templates/input.component';
import { TableSelectMultiComponent } from './templates/select.component';
import { ImportModalContentComponent } from './templates/modal.component';
import { NzImageModule } from 'ng-zorro-antd/image';
import { IComMessageService } from '../../../services/common';
import { ShowTooltipOnOverflowDirective } from './directive/tooltip.directive';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { FormlyValueChangeEvent } from '@ngx-formly/core/lib/models';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { FormatValuePipe } from './pipes/format-value.pipe';
import { cloneDeep } from 'lodash';
@Component({
  selector: 'icom-libs-core-component-dropdown-table',
  templateUrl: './dropdown-table.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [
    NzTableModule,
    NzSelectModule,
    ReactiveFormsModule,
    FormlyNgZorroAntdModule,
    FormlyModule,
    NgIf,
    NgForOf,
    FormsModule,
    AsyncPipe,
    NzButtonModule,
    NzIconModule,
    NzPaginationModule,
    DragDropModule,
    NgStyle, NgClass, NgSwitchCase, NgSwitch,
    TableInputComponent,
    TableSelectMultiComponent,
    DecimalPipe,
    NzImageModule,
    ShowTooltipOnOverflowDirective,
    NzSpinModule,
    JsonPipe,
    NzToolTipModule,
    NzSpinModule,
    NzButtonModule,
    FormatValuePipe
  ],
  providers: [PaginationService],
  styles: [
    `
      ::ng-deep .cdk-drag-preview {
        display: table;
      }

      ::ng-deep .cdk-drag-placeholder {
        td {
          height: 60px;
          opacity: 0;
        }
      }
      .loading-container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
      }
      ::ng-deep .cdk-drag-preview {
        display: table;
      }
      .placeholder-td {
        height: 100px;
        text-align: center;
        border: 2px dashed gray;
        background-color: #eeeeee;
      }
      .highlighted {
        background-color: yellow; /* Màu tô màu cho dòng được chọn */
      }
    `,
  ],
})
export class DropdownTableTypeComponent extends FieldType<FieldTypeConfig>   {
  protected selectedValue: any;
  public pagedItems: any[] = [];
  public totalPages: number = 0;
  protected getCurrentPage: number = 0;
  protected fallback =
    'data:image/png;base64,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';
  protected isLoading!: boolean;

  protected optionList: any[] = [];
  protected pagination: any;
  protected searchChange$ = new Subject<any>();
  protected keySearch!: string;

  protected IComMessageService = inject(IComMessageService);
  protected cdr = inject(ChangeDetectorRef);
  protected paginationService = inject(PaginationService);
  protected modalService = inject(NzModalService);
  protected isFirst: boolean = true;
  protected valueCurrent: any;

  @ViewChildren('tableRow') tableRows!: QueryList<ElementRef>;
  @ViewChildren('templates') templates!: QueryList<any>;

  @Output() icomFunctionControl: EventEmitter<any> = new EventEmitter();

  constructor() {
    super();
  }

  async ngOnInit() {
    this.searchChange$.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      switchMap((term: string) => {
        this.isLoading = true;
        this.optionList = this.optionList.map(option => ({ ...option, disabled: true }));
        this.cdr.detectChanges();
        this.keySearch = term;
        return this.searchData(term);
      })
    ).subscribe((data: any) => {
      this.isLoading = false;
      this.optionList = data?.length ? data : data?.items;
      this.pagination = data?.pagination;
      this.cdr.detectChanges();
    }, (err) => {
      this.isLoading = false;
      this.cdr.detectChanges();
    });
    this.icomFunctionControl.emit({
      reset: () => {
        this.pagedItems = [];
        this.updatePageItems();
      }
    })
    this.props?.callBackThis && this.props?.callBackThis(this);
    this.props.keyGetValue && this.field.options?.fieldChanges?.subscribe((result: FormlyValueChangeEvent) => {
      if (result.field.key === this.props.keyGetValue) {
        this.paginationService.resetItems();
        this.updatePageItems();
        this.props.changeItems && this.props.changeItems(this.pagedItems, this.field);
        this.cdr.detectChanges();
      }
    });

    if (this.props?.listDataMapping) {
      const dataMapping: any = this.props?.listDataMapping;
      let result;
      if (dataMapping instanceof Observable) {
        result = await lastValueFrom(dataMapping);
      } else {
        result = dataMapping;
      }
      if (result) {
        result.forEach((item: any) => {
          item.name = item.product_name;
        });
        this.mergeApiDataToSelectedItem(result, this.formControl.value);
        this.formControl.patchValue(this.formControl.value);
        this.paginationService.setItems(this.formControl.value);
        this.updatePageItems();
        this.cdr?.detectChanges();
      }
      this.cdr.detectChanges();
      return;
    } else {
      this.formControl.patchValue(this.formControl.value);
      this.paginationService.setItems(this.formControl.value);
      this.updatePageItems();
      this.cdr.detectChanges();
    }
  }

  private searchData(term: string): Observable<any[]> {
    return this.props.listOptionDropdown(1, { [this.props.keySearch || 'search'] : term });
  }

  isNumber(value: any): boolean {
    return typeof value === 'number';
  }

  isString(value: any): boolean {
    return typeof value === 'string';
  }


  loadMore(): void {
    if (!this.props?.nzServerSearch) {
      return;
    }
    if (this.pagination.total_pages === this.pagination.page) {
      return;
    }
    this.isLoading = true;
    this.optionList = this.optionList.map(option => ({ ...option, disabled: true }));
    this.props?.listOptionDropdown && this.props?.listOptionDropdown(this.pagination.page + 1, { [this.props.keySearch || 'search']: this.keySearch }).subscribe((data: any) => {
      this.isLoading = false;
      const dataPush = (data?.length) ? data : data?.items;
      this.optionList = [...this.optionList, ...dataPush];
      this.optionList = this.optionList.map(option => ({ ...option, disabled: false }));
      this.pagination = data?.pagination;
      this.cdr.detectChanges();
    });
  }

  onSearch(searchText: string) {
    if (!this.props?.nzServerSearch) {
      return;
    }
    this.searchChange$.next(searchText);
  }

  protected handlerSelectChange(value: any) {
    const selectedOption = this.optionList.find((option: any) => option.id === value);
    if (this.props.mergeApiDataToSelectedItem) {
      this.handleApiData(selectedOption);
      return;
    }
    this.updateTable(selectedOption);
  }

  protected updateTable(selectedOption: any): boolean {
    let exists = false;
    if (selectedOption) {
      if (this.props?.functionCheckCondition) {
        exists = this.props?.functionCheckCondition(selectedOption);
      }
      if (!exists) {
        exists = this.paginationService.itemExists(selectedOption);
      }
      if (!exists) {
        this.addItem(selectedOption);
        this.selectedValue = undefined;
        this.cdr?.detectChanges();
      } else {
        const pageIndex = this.paginationService.findPageIndex(selectedOption);
        this.setCurrentPage(pageIndex + 1);
        this.highlightRow(selectedOption);
        this.selectedValue = undefined;
        this.cdr?.detectChanges();
      }
      this.props.changeItems && this.props.changeItems(this.paginationService.getItems(), this.field);
    }
    return exists;
  }

  protected handlerChange(event: any, data: any, field: string) {
    if (!data[field]) {
      data[field] = '';
    }
    data[field] = event;
    this.props.changeItems && this.props.changeItems(this.paginationService.getItems(), this.field);
  }

  private handleApiData(selectedOption: any) {
    this.props.mergeApiDataToSelectedItem([selectedOption.id]).subscribe({
      next: (apiResponse: any) => {
        this.mergeApiDataToSelectedItem(apiResponse, [selectedOption]);
      },
      error: (err: any) => {
        console.error('Error fetching data from API:', err);
      }
    });
  }

  protected mergeApiDataToSelectedItem(apiData: any[], selectedOption: any) {
    selectedOption && selectedOption?.forEach((dataMapping: any) => {
      const dataMap = apiData.find((item => (item.product_id === dataMapping.id || item.product_id === dataMapping.product_id)));
      dataMap && Object.assign(dataMapping, dataMap);
      this.updateTable(dataMapping);
    });
  }

  onSelectOpenChange(open: boolean): void {
    if (open) {
      this.isLoading = true;
      this.props?.listOptionDropdown && (this.props?.listOptionDropdown(1, {}) as any)?.subscribe(
        (data: any) => {
          this.isLoading = false;
          this.optionList = data?.length ? data : data?.items;
          this.pagination = data?.pagination;
          this.cdr.detectChanges();
        }, (err: any) => {
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      )
    }
  }

  onImageError(event: any) {
    if (event.target.src === 'data:image/png;base64,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') {
      return;
    }
    event.target.src = 'data:image/png;base64,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'; // Đường dẫn ảnh mặc định
  }

  public addItem(item: any): void {
    this.paginationService.addItem(item);
    this.pagedItems = this.paginationService.getItems();
    this.cdr.detectChanges();
  }

  public removeItem(e: Event, item: any): void {
    e.stopPropagation();
    e.preventDefault();
    this.modalService.confirm(
      {
        nzTitle: `Bạn có chắc chắn muốn xóa không?`,
        nzOkText: 'Đồng ý',
        nzOkType: 'primary',
        nzMaskClosable: false,
        nzClosable: false,
        nzOnOk: () => {
          this.paginationService.removeItem(item);
          this.updatePageItems();
          this.cdr.detectChanges();
          this.props.changeItems && this.props.changeItems(this.paginationService.getItems(), this.field);
        },
        nzCancelText: 'Hủy bỏ',
      },
      'error'
    );
  }

  public setCurrentPage(page: number): void {
    this.paginationService.setCurrentPage(page);
    this.updatePageItems();
  }

  private updatePageItems(): void {
    this.paginationService.recalculatePagination();
    this.getCurrentPage = this.paginationService.getCurrentPage();
    this.pagedItems = this.paginationService.getCurrentPageItems();
    this.totalPages = this.paginationService.getTotalPages();
    this.cdr?.detectChanges();
  }

  protected drop(event: CdkDragDrop<string[]>): void {
    if (this.props.readonly) {
      return;
    }
    const prevIndex = event.previousIndex + (this.paginationService.getCurrentPage() - 1) * this.paginationService.getPageSize();
    const newIndex = event.currentIndex + (this.paginationService.getCurrentPage() - 1) * this.paginationService.getPageSize();
    moveItemInArray(this.paginationService.getItems(), prevIndex, newIndex);
    this.updatePageItems();
    this.props.changeItems && this.props.changeItems(this.paginationService.getItems(), this.field);
    this.cdr.detectChanges();
  }

  private removeHighLight() {
    this.tableRows.forEach((row) => {
      row.nativeElement.classList.remove('highlighted');
    });
  }

  private highlightRow(item: any) {
    const rowElement = this.tableRows?.find(
      (row) => row.nativeElement.id === 'row-' + item.id
    );
    if (rowElement) {
      rowElement.nativeElement.classList.add('highlighted');
      rowElement.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    }
    this.cdr.detectChanges();
  }

  protected onPageSizeChange(page: number) {
    this.paginationService.setPageSize(page);
    this.updatePageItems();
  }

  public handlerSave() {
    let valid = true;
    for (let temp of this.templates) {
      const result = temp.save();
      this.cdr.detectChanges();
      if (!result.valid) {
        valid = false;
        this.highlightRow(result.dataRow);
      }
      if (this.props.specificValidate) {
        const resultSpecificValidate = this.props.specificValidate(result.dataRow);
        !resultSpecificValidate && this.highlightRow(result.dataRow);
        !resultSpecificValidate && (valid = false);
      }
    };
    return valid;
  }

  public openImportModal(e: Event): void {
    e.stopPropagation();
    e.preventDefault();
    const modalRef = this.modalService.create({
      nzTitle: 'Nhập voucher từ File dữ liệu',
      nzContent: ImportModalContentComponent,
      nzOkLoading: false,
      nzCancelText: 'Hủy bỏ',
      nzOkText: 'Đồng ý',
      nzOkType: 'primary',
      nzData: this.props?.objectUpload,
      nzOnOk: () => new Promise((resolve) => {
        const instance = modalRef.getContentComponent();
        instance.onSave.pipe(take(1)).subscribe(result => {
          if (result) {
            let count  = 0;
            result && result.length && result.forEach((item: any) => {
              count += (!this.updateTable(item) ? 1 : 0);
            })
            this.cdr?.detectChanges();
            this.IComMessageService.showAlertMessageDone(`Đã import thành công ${count || 0} bản ghi`);
            resolve(true);
          } else {
            resolve(false);
            modalRef.updateConfig({ nzOkLoading: false });
            this.cdr?.detectChanges();
          }
        });
        instance.handleImport();
      }),
    });
  }
}
